import { render, staticRenderFns } from "./ShowcasesSlider.vue?vue&type=template&id=7d883e50&"
import script from "./ShowcasesSlider.vue?vue&type=script&lang=js&"
export * from "./ShowcasesSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports